// extracted by mini-css-extract-plugin
export default {"galleryHeader":"c-n_gm"};